import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../../utils/Methods";
import { IDS } from "../../../../../utils/IDS";

// role - Get All (Read)
export const GetAll = createAsyncThunk(
  "environmental_condition/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Environmental_Condition}?term=${filter?.name ||
          ""}&page=${filter?.page || IDS.PAGE}&per_page=${filter?.per_page ||
          IDS.PERPAGE}&management_data_id=${filter?.management_data_id ||
          ""}&instrument_id=${filter?.instrument_id ||
          ""}&instrument_name=${filter?.instrument_name ||
          ""}&start_date=${filter?.start_date ||
          ""}&end_date=${filter?.end_date || ""}`,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// role - Get (Read)
export const GetSingle = createAsyncThunk(
  "environmental_condition/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Environmental_Condition}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

// role - Create (Add)
export const Create = createAsyncThunk(
  "environmental_condition/create",

  async (data, { rejectWithValue }) => {
    console.log("this is called");
    try {
      const res = await POST(APIS.Environmental_Condition, data);

      console.log("resresresres", res);
      return res; // The new role object
    } catch (error) {
      console.log(error, "error");

      return rejectWithValue(error);
    }
  },
);

// // role - Update
// export const Update = createAsyncThunk(
//   "environmental_condition/update",
//   async ({ id, sendData }, { rejectWithValue }) => {
//     try {
//       const res = await PUT(`${APIS.Environmental_Condition}/${id}`, sendData);
//       return res;
//     } catch (error) {
//       return rejectWithValue(error);
//     }
//   },
// );

// // role - Delete
// export const Delete = createAsyncThunk(
//   "environmental_condition/delete",
//   async (id, { rejectWithValue }) => {
//     try {
//       const data = await DELETE(`${APIS.Environmental_Condition}/${id}`);
//       return id; // Return the id of the deleted role
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   },
// );

// // role - Status
// export const StatusRole = createAsyncThunk(
//   "environmental_condition/status",
//   async (id, { rejectWithValue }) => {
//     try {
//       const res = await POST(`${APIS.Environmental_Condition}/${id}`);
//       return res;
//     } catch (error) {
//       return rejectWithValue(error.message);
//     }
//   },
// );

export const ReportGenerate = createAsyncThunk(
  "environmental_condition/generate-report",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Environmental_Condition}/report/${
          filter?.room_type_id
        }?term=${filter?.name || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}&room_type_id=${
          filter?.room_type_id
        }&start_date=${filter?.start_date || ""}&end_date=${filter?.end_date ||
          ""}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);
export const Slice = createSlice({
  name: "environmental_condition",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(ReportGenerate.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(ReportGenerate.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(ReportGenerate.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });

    // .addCase(Update.pending, (state) => {
    //   state.status = IDS.SLICESTATUS.Loading;
    // })
    // .addCase(Update.fulfilled, (state, action) => {
    //   state.status = IDS.SLICESTATUS.Succeeded;
    //   // state.data = action.payload;
    //   const index = state.data.findIndex(
    //     (role) => role.id === action.payload?.data?.id,
    //   );
    //   if (index !== -1) {
    //     state.data[index] = action.payload.data;
    //   }
    // })
    // .addCase(Update.rejected, (state, action) => {
    //   state.status = IDS.SLICESTATUS.Failed;
    //   state.error = action.payload;
    // })

    // .addCase(Delete.pending, (state) => {
    //   state.status = IDS.SLICESTATUS.Loading;
    // })
    // .addCase(Delete.fulfilled, (state, action) => {
    //   state.status = IDS.SLICESTATUS.Succeeded;
    //   // state.data = action.payload;
    //   state.data = state.data.filter((role) => role.id !== action.payload.id); // Remove the role with the deleted id
    // })
    // .addCase(Delete.rejected, (state, action) => {
    //   state.status = IDS.SLICESTATUS.Failed;
    //   state.error = action.payload;
    // })
    // //
    // .addCase(StatusRole.pending, (state) => {
    //   state.status = IDS.SLICESTATUS.Loading;
    // })
    // .addCase(StatusRole.fulfilled, (state, action) => {
    //   state.status = IDS.SLICESTATUS.Succeeded;
    //   // state.data = action.payload;
    //   state.data = state.data.filter((role) => role.id !== action.payload.id); // Remove the role with the deleted id
    // })
    // .addCase(StatusRole.rejected, (state, action) => {
    //   state.status = IDS.SLICESTATUS.Failed;
    //   state.error = action.payload;
    // });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
